export default __webpack_public_path__ + "static/media/FMoCImg.57cf897c.jpg";